import React from 'react';

import { OfferCard } from '@/components/Shared/ui';
import { BANKS_ICONS_NAMES, BankNames, DictTypes } from '@/constants';
import { safeKey } from '@/services/helpers/dict';
import { useAppSelector } from '@/store';

import type { TRequestBodyInfoProps } from '../../entities';

interface BankOffersErrorProps {
  bank?: BankNames;
  extId?: string;
  requestBodyInfo?: TRequestBodyInfoProps;
}

const BankOffersError: React.FC<BankOffersErrorProps> = ({
  bank,
  extId,
  requestBodyInfo
}) => {
  const { dicts } = useAppSelector((state) => state.dict);

  const bankDict = dicts?.[DictTypes.Banks]?.getBy.name[safeKey(bank)];
  const bankIconName = bank ? BANKS_ICONS_NAMES[bank] : null;

  return (
    <OfferCard
      className="bank-item"
      status="error"
      extId={extId}
      statusText={'Ошибка'}
    >
      <OfferCard.Header
        title={bankDict?.fullname || bankIconName?.name}
        icon={bankDict?.icon || bankIconName?.icon}
        requestBodyInfo={requestBodyInfo}
      />
    </OfferCard>
  );
};

export default BankOffersError;
